// extracted by mini-css-extract-plugin
export default {"disconect":"Monitoring_disconect__LNrf5","offline":"Monitoring_offline__LBP1B"};